import React, { cloneElement, isValidElement } from "react";
import { usePermissions } from "../../providers/PermissionsProvider";
// Extracted into its own component to make testing/stories easier.
export function PermissionsCheckRenderer({ hasPermission, shouldHideChildren, children, }) {
    if (hasPermission)
        return React.createElement(React.Fragment, null, children);
    if (!shouldHideChildren && isValidElement(children)) {
        return (React.createElement(React.Fragment, null, cloneElement(children, {
            disabled: true,
        })));
    }
    return React.createElement(React.Fragment, null);
}
export default function PermissionsCheck({ permission, groupId, shouldHideChildren, children, }) {
    const { hasPermission, loading } = usePermissions();
    const multiple = Array.isArray(permission);
    if (!permission)
        return React.createElement(React.Fragment, null, children);
    if (multiple && permission.length === 0)
        return React.createElement(React.Fragment, null, children);
    const permissionsToCheck = multiple
        ? permission
        : [permission];
    const hasRequiredPermissions = permissionsToCheck.every((currentPermission) => hasPermission(currentPermission, groupId));
    if (loading)
        return null;
    return (React.createElement(PermissionsCheckRenderer, { hasPermission: hasRequiredPermissions, shouldHideChildren: shouldHideChildren || false }, children));
}
PermissionsCheck.defaultProps = {
    shouldHideChildren: false,
    permission: "",
    groupId: "",
};
//# sourceMappingURL=index.js.map